import { getNow } from '@kathondvla/sri-client/date-utils';
import { EDUCATION_LEVEL_MAP } from 'ReduxLoop/constants';
import { settings } from 'Js/config/settings';
import { currentOuFetched } from 'ReduxLoop/ouManager/schoolManagerActions';
import { sriClient } from '../utils/apiConfig';

export const getGoverningInstitutionOfOu = async (ou) => {
  const giRels = await sriClient.getAll('/sam/organisationalunits/relations', {
    to: ou.$$meta.permalink,
    type: 'GOVERNS',
    endDateAfter: getNow(),
    expand: 'results.from',
  });
  if (giRels.length === 0) {
    return {};
  }
  const governingInstitution = giRels[0].from.$$expanded;
  const mailContactDetails = await sriClient.getAll('/sam/organisationalunits/contactdetails', {
    organisationalUnit: governingInstitution.$$meta.permalink,
    type: 'MAIL',
  });
  return { governingInstitution, mailContactDetail: mailContactDetails[0] };
};

export const getMainstructuresForOu = async (ou) => {
  if (ou.type !== 'SCHOOL' && ou.type !== 'SCHOOLENTITY') {
    return [];
  }
  const epds = await sriClient.getAll('/sam/educationalprogrammedetails', {
    organisationalUnit: ou.$$meta.permalink,
    hasMainstructure: true,
    expand: 'results.mainstructure',
  });
  return epds.map((epd) => epd.mainstructure.$$expanded);
}

const typesThatStillNeedToReferToVos = new Set([
  'SCHOOL',
  'BOARDING',
  'SCHOOLCOMMUNITY',
]);
const getPathForVosInsitution = async (ou, educationLevel, institutionNumber) => {
  if (ou.type !== 'SCHOOL') {
    return ou.type === 'BOARDING' ? `/boardings/${institutionNumber}` : `/schoolcommunities/${institutionNumber}`;
  }
  if (educationLevel === 'ADULT') {
    return `/cvos/${institutionNumber}`
  }
  return `/schools/${institutionNumber}`;
}
export const getVosEquivalent = async (ou, educationLevel) => {
  if (ou.$$meta.permalink.match(/\/kathondvla\/organisationalunits\//)) {
    return `/organisations/${ou.key}`;
  }
  if (!typesThatStillNeedToReferToVos.has(ou.type)) {
    return ou.$$meta.permalink;
  }
  const externalIdentifiers = await sriClient.getAll(
    '/sam/organisationalunits/externalidentifiers',
    {
      typeIn: 'INSTITUTION_NUMBER',
      organisationalUnit: ou.$$meta.permalink,
    }
  );
  const institutionNumber = externalIdentifiers[0];
  if (institutionNumber) {
    const path = await getPathForVosInsitution(ou, educationLevel, institutionNumber.value);
    const vosOu = await sriClient.get(path);
    if (vosOu) {
      return vosOu.$$meta.permalink;
    }
  }
  console.warn(
    `Er is geen VOS equivalent gevonden voor ${ou.$$meta.permalink} van type ${ou.type}!!!!!`
  );
  return null;
};
